/*
 * Copyright (c) 2020.
 * Simon
 */

export default function userInfoSave(data, service) {
    let key = 'user_' + service;
    localStorage.setItem(key, JSON.stringify(data));
}
